module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-5c85a0ad2ba229b14e181c8fcf351998.png";